import {array} from 'prop-types';
import Header from '../../shared/Header';
import {useTranslation} from "react-i18next";
import AddressSection from "../house/AddressSection";
import useIconLibrary from "../../../hooks/useIconLibrary";

const AddressesBlock = ({ addresses }) => {
  const { t } = useTranslation();
  const { HouseIcon } = useIconLibrary();

  const getAddressTypeTranslation = (address) => {
    switch (address.type) {
      case 'visiting':
        return t('Bezoekadres');
      case 'billing':
        return t('Factuuradres');
      case 'delivery':
        return t('Afleveradres');
      case 'general':
        return t('Algemeen adres');
      case 'private':
        return t('Privéadres');
      case 'correspondence':
        return t('Correspondentieadres');
      default:
        return t('Unknown');
    }
  }

  return (
    <>
      <Header
        title={t("Adressen")}
        icon={<HouseIcon height="2rem" width="2rem" />}
        variant="page"
      />
      {addresses.map((address, index) => (
        <AddressSection
          key={`typed-address-${index}`}
          {...{
            ...address,
            handleChange: () => null,
            readOnly: true,
            title: getAddressTypeTranslation(address)
          }} />
      ))}
    </>
  );
};

AddressesBlock.propTypes = {
  addresses: array,
};

AddressesBlock.defaultProps = {
  addresses: [],
};

export default AddressesBlock;
